module.exports = __webpack_public_path__ + "static/media/trash-undo.08d59b17.svg";